import React from 'react'
import PageHeader from '../components/shared/pageHeader/PageHeader'
import LeadsCreateHeader from '../components/leads/TestHeader'
import LeadsCreateContent from '../components/leads/TestTable'
import Footer from '../components/shared/Footer'

const OrganisationTable = () => {
    return (
        <>
            <PageHeader>
                <LeadsCreateHeader />
            </PageHeader>

            <div className='main-content'>
                <div className='row'>
                    <LeadsCreateContent/>
                </div>
            </div>
            
        </>
    )
}

export default OrganisationTable